/* eslint-disable react/prop-types */
import React, { useEffect, useMemo } from 'react';

import Autocomplete from '../../../../../../shared/ui/Autocomplete/Autocomplete';
import { useLazyGetDivisionsResourceQuery } from '../../../../../../entities/divisions/divisionsResource/redux/divisionsResource.api';

function DivisionsAutocomplete({ label, value, initialDivisionId, id, onChange, companyId, required }) {
  const [getDivisions, divisions] = useLazyGetDivisionsResourceQuery();

  useEffect(() => {
    getDivisions({
      params: {
        'companyId.equals': companyId,
      },
    });
  }, [getDivisions, companyId]);

  const divisionsData = useMemo(
    () =>
      divisions?.data?.data?.map((division, i) => ({
        id: i,
        divisionId: division.divisionId,
        name: division.name,
      })) || [],
    [divisions?.data],
  );

  const currentValue = useMemo(() => {
    if (!initialDivisionId || value?.divisionId || value === null) return value || null;

    const divisionId = Number(initialDivisionId);
    return divisionsData.find((division) => division.divisionId === divisionId) || value || null;
  }, [initialDivisionId, divisionsData, value]);

  return (
    <Autocomplete
      id={id}
      label={label}
      value={currentValue}
      values={divisionsData}
      loading={divisions?.isLoading}
      onChange={onChange}
      required={required}
    />
  );
}

export default DivisionsAutocomplete;
